import { getApiClient } from "@punchup/utils";
import { Podcast, PodcastInsert } from "../../models/podcasts";

export async function getComedianManagerPodcasts(comedianId: string) {
  return getApiClient()
    .get<{ data: Podcast[] }>(
      `/api/v2/manager/podcasts?owner_comedian_id=${comedianId}`
    )
    .then((data) => data.data);
}

export async function createPodcast(params: PodcastInsert) {
  return await getApiClient().post<{ data: Podcast }>(
    "/api/v2/manager/podcasts",
    params
  );
}

export async function updatePodcast(
  podcastId: string,
  params: {
    name?: string;
    slug?: string;
    description?: string;
    poster_image_id?: string | null;
    requires_subscription?: boolean;
    requires_purchase?: boolean;
    subscription_product_id?: string | null;
    required_subscription_tier?: number | null;
  }
): Promise<Podcast> {
  return getApiClient()
    .patch<{ data: Podcast }>(`/api/v2/manager/podcasts/${podcastId}`, params)
    .then((data) => data.data);
}

export async function removeVideoFromPodcast(
  podcastId: string,
  specialId: string
): Promise<void> {
  await getApiClient().del(
    `/api/v2/manager/podcasts/${podcastId}/episodes/${specialId}`
  );
}

export async function addVideosToPodcast(
  podcastId: string,
  specialIds: string[]
): Promise<void> {
  await getApiClient().post(`/api/v2/manager/podcasts/${podcastId}/episodes`, {
    special_ids: specialIds,
  });
}

export async function publishPodcast(podcastId: string): Promise<Podcast> {
  return getApiClient()
    .post<{ data: Podcast }>(`/api/v2/manager/podcasts/${podcastId}/publish`)
    .then((data) => data.data);
}
